import $ from 'jquery';

import './header.css';

$(document).ready(function () {
  var btn = $('#copyButton');

  btn.on('click', function (e) {
    copyToClipboard(document.getElementById('copyTarget'));
    $('.copy__text').addClass('copy__text-open');
    setTimeout(function () {
      $('.copy__text').removeClass('copy__text-open');
    }, 1000);
  });

  function copyToClipboard(elem) {
    var targetId = '_hiddenCopyText_';
    var isInput = elem.tagName === 'INPUT' || elem.tagName === 'TEXTAREA';
    var origSelectionStart, origSelectionEnd;
    if (isInput) {
      target = elem;
      origSelectionStart = elem.selectionStart;
      origSelectionEnd = elem.selectionEnd;
    } else {
      target = document.getElementById(targetId);
      if (!target) {
        var target = document.createElement('textarea');
        target.style.position = 'absolute';
        target.style.left = '-9999px';
        target.style.top = '0';
        target.id = targetId;
        document.body.appendChild(target);
      }
      target.textContent = elem.textContent;
    }
    var currentFocus = document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);
    var succeed;
    try {
      succeed = document.execCommand('copy');
    } catch (e) {
      succeed = false;
    }
    if (currentFocus && typeof currentFocus.focus === 'function') {
      currentFocus.focus();
    }
    if (isInput) {
      elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
      target.textContent = '';
    }
    return succeed;
  }
});
